import axios from "axios";

export default {
    getUsers(_, params) {
        return axios.post('/api/auth/getusers', params, { withCredentials: true });
    },
    registerUser(_, params) {
        return axios.post('/api/auth/registeruser', params, { withCredentials: true });
    },
    deleteUser(_, params) {
        return axios.post('/api/auth/deleteuser', params, { withCredentials: true });
    },
    updateUser(_, params) {
        return axios.post(`/api/auth/updateuser/${params.user_id}`, params.body, { withCredentials: true });
    },
    bulkRegisterUser(_, params) {
        return axios.post('/api/auth/bulkregisteruser', params, { withCredentials: true });
    },
    getUserToken(_, params) {
        return axios.get(`/api/verification/registerform?token=${params.token}`, params, { withCredentials: true });
    },
    postUserToken(_, params) {
        return axios.post(`/api/verification/registerupdate?token=${params.token}`, params, { withCredentials: true });
    },
    getRoles(_, params) {
        return axios.get(`/api/auth/getroles/${params.role_id}`, { withCredentials: true });
    },
    getDepartments(_, params) {
        return axios.post('/api/userdepartment/getuserdepartments', params, { withCredentials: true });
    },
    getCompanies(_, params) {
        return axios.post('/api/company/getcompanies', params, { withCredentials: true });
    },
    getCompaniesByUser(_, params) {
        return axios.post(`/api/company/getcompanieswusers/${params.user_id}`,
            { is_deleted: params.is_deleted, role_id: params.role_id }, { withCredentials: true });
    },
    registerToken(_, params) {
        return axios.post(`/api/verification/email?token=${params.token}`, {}, { withCredentials: true });
    },

    registerCompany(_, params) {
        return axios.post(`/api/company/updatecompany`, params, { withCredentials: true });
    },

    deleteCompany(_, params) {
        return axios.post(`/api/company/deletecompany`, params, { withCredentials: true });
    },

    getProcessTrack(_, params) {
        return axios.post('/api/reportingprocesstrack/getreportingprocesstracksbycompanyid', params, { withCredentials: true });
    },

    setProcessTrackId({ commit }, process_track_id) {
        commit('SET_PROCESS_TRACK_ID', process_track_id);
    },

    setProcessSteps({ commit }, steps) {
        commit('SET_PROCESS_STEPS', steps);
    },

    createProcessTrack(_, params) {
        return axios.post('/api/reportingprocesstrack/createreportingprocesstrack', params, { withCredentials: true });
    },

    updateProcessTrack(_, params) {
        return axios.post(`/api/reportingprocesstrack/updatereportingprocesstrack/${params.reporting_process_track_id}`,
            {
                is_step_1_completed: params.is_step_1_completed,
                is_step_2_completed: params.is_step_2_completed,
                is_step_3_completed: params.is_step_3_completed,
                is_step_4_completed: params.is_step_4_completed,
                is_step_5_completed: params.is_step_5_completed,
                is_step_6_completed: params.is_step_6_completed,
                is_step_7_completed: params.is_step_7_completed,
                is_step_8_completed: params.is_step_8_completed,
                is_step_9_completed: params.is_step_9_completed,
                is_step_10_completed: params.is_step_10_completed,
                is_step_11_completed: params.is_step_11_completed,
                is_step_12_completed: params.is_step_12_completed,
                is_step_13_completed: params.is_step_13_completed,
                is_step_14_completed: params.is_step_14_completed,
                updated_by: params.updated_by
            }, { withCredentials: true });
    },

    getUserInfo(_, params) {
        return axios.post('/api/auth/getuserinfo', params, { withCredentials: true });
    },

    sendResetPasswordMail(_, params) {
        return axios.post('/api/auth/sendresetpassword', params, { withCredentials: true });
    },
    resetPassword(_, params) {
        return axios.post('/api/auth/resetpassword', params, { withCredentials: true });
    },

    // optimized //

    getCompanyOfUser(_, params) {
        return axios.post(
            "/api/company/getcompanyofuser",
            params,
            {
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`
                }
            }
        );
    },

    getUsersOfCompany(_, params) {
        return axios.post(`/api/company/getusersbycompanyid`, params, { withCredentials: true });
    },

    getSampleExcel() {
        return axios.get(`/api/auth/getexamplefile/excel`, { responseType: "blob" });
    },

    exportUsers(_, params) {
        return axios.post("/api/company/exportusers", params, { responseType: "blob", withCredentials: true });
    },

    getTeamMembers() {
        return axios.get('/api/company/get-team-members', {withCredentials: true});
    },
    
    getInternalStakeholders(_, params) {
        return axios.get(`/api/company/get-internal-stakeholders/${params.keyword}`, {withCredentials: true});
    },
    
    updateCarbonAssignment(_, params) {
        return axios.post('/api/company/update-carbon-assignments', params, { withCredentials: true });
    },
}   